var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-stepper",
    { ref: "newTeamStepper", staticClass: "new-team-stepper" },
    [
      _c(
        "q-step",
        { staticClass: "q-px-lg", attrs: { title: "", default: "" } },
        [
          _c("div", { staticClass: "text-center" }, [
            _c(
              "span",
              { staticClass: "block q-headline q-mb-sm q-mt-lg text-dark" },
              [_vm._v(_vm._s(_vm.$t("new_team_stepper.step_1.title")))]
            ),
            _c("span", { staticClass: "q-title text-light" }, [
              _vm._v(_vm._s(_vm.$t("new_team_stepper.step_1.subtitle")))
            ])
          ]),
          _c(
            "div",
            { staticClass: "q-mt-xl" },
            [
              _c("legal-form-selector", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate.disable",
                    value: "required",
                    expression: "'required'",
                    modifiers: { disable: true }
                  }
                ],
                attrs: { name: "legalForm" },
                model: {
                  value: _vm.formData.legalForm,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "legalForm", $$v)
                  },
                  expression: "formData.legalForm"
                }
              }),
              _c("div", { staticClass: "q-mt-md text-center" }, [
                _vm.errors.has("legalForm")
                  ? _c("span", { staticClass: "text-negative" }, [
                      _vm._v(_vm._s(_vm.errors.first("legalForm")))
                    ])
                  : _vm._e()
              ])
            ],
            1
          ),
          _c(
            "q-stepper-navigation",
            { staticClass: "justify-end" },
            [
              _vm.hasTeam
                ? _c(
                    "q-btn",
                    {
                      staticClass: "on-left",
                      attrs: { flat: "", "text-color": "grey-7" },
                      on: { click: _vm.handleCancel }
                    },
                    [_vm._v(_vm._s(_vm.$t("cancel")))]
                  )
                : _vm._e(),
              _c(
                "q-btn",
                {
                  attrs: { color: "teal" },
                  on: { click: _vm.handleLegalFormNext }
                },
                [_vm._v(_vm._s(_vm.$t("next")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "q-step",
        { staticClass: "q-px-lg", attrs: { title: "" } },
        [
          _c("div", { staticClass: "text-center" }, [
            _c(
              "span",
              { staticClass: "block q-headline q-mb-sm q-mt-lg text-dark" },
              [_vm._v(_vm._s(_vm.$t("new_team_stepper.step_2.title")))]
            ),
            _c("span", { staticClass: "q-title text-light" }, [
              _vm._v(_vm._s(_vm.$t("new_team_stepper.step_2.subtitle")))
            ])
          ]),
          _c(
            "div",
            { staticClass: "q-mt-xl" },
            [
              _c("small-business-selector", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate.disable",
                    value: "required",
                    expression: "'required'",
                    modifiers: { disable: true }
                  }
                ],
                attrs: { name: "smallBusiness" },
                model: {
                  value: _vm.formData.isSmallBusiness,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "isSmallBusiness", $$v)
                  },
                  expression: "formData.isSmallBusiness"
                }
              }),
              _c("div", { staticClass: "q-mt-md text-center" }, [
                _vm.errors.has("smallBusiness")
                  ? _c("span", { staticClass: "text-negative" }, [
                      _vm._v(_vm._s(_vm.errors.first("smallBusiness")))
                    ])
                  : _vm._e()
              ])
            ],
            1
          ),
          _c(
            "q-stepper-navigation",
            { staticClass: "justify-end" },
            [
              _vm.hasTeam
                ? _c(
                    "q-btn",
                    {
                      staticClass: "on-left",
                      attrs: { flat: "", "text-color": "grey-7" },
                      on: { click: _vm.handleCancel }
                    },
                    [_vm._v(_vm._s(_vm.$t("cancel")))]
                  )
                : _vm._e(),
              _c(
                "q-btn",
                {
                  staticClass: "on-left",
                  attrs: { flat: "", color: "teal" },
                  on: { click: _vm.handlePrevious }
                },
                [_vm._v(_vm._s(_vm.$t("back")))]
              ),
              _c(
                "q-btn",
                {
                  attrs: { color: "teal" },
                  on: { click: _vm.handleLegalFormNext }
                },
                [_vm._v(_vm._s(_vm.$t("next")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "q-step",
        { staticClass: "q-px-lg", attrs: { title: "" } },
        [
          _c("div", { staticClass: "text-center" }, [
            _c(
              "span",
              { staticClass: "block q-headline q-mb-sm q-mt-lg text-dark" },
              [_vm._v(_vm._s(_vm.$t("new_team_stepper.step_3.title")))]
            ),
            _c("span", { staticClass: "q-title text-light" }, [
              _vm._v(_vm._s(_vm.$t("new_team_stepper.step_3.subtitle")))
            ])
          ]),
          _c(
            "div",
            { staticClass: "q-mt-xl" },
            [
              _c(
                "q-field",
                {
                  attrs: {
                    label: _vm.$t("team_name"),
                    labelWidth: 3,
                    error: _vm.errors.has("teamName"),
                    "error-label": _vm.errors.first("teamName")
                  }
                },
                [
                  _c("q-input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate.disable",
                        value: "required|min:1|max:255",
                        expression: "'required|min:1|max:255'",
                        modifiers: { disable: true }
                      }
                    ],
                    attrs: {
                      name: "teamName",
                      placeholder: _vm.$t("team_name")
                    },
                    model: {
                      value: _vm.formData.name,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "name", $$v)
                      },
                      expression: "formData.name"
                    }
                  })
                ],
                1
              ),
              _c("address-input", {
                attrs: { required: "", expanded: "", labelWidth: 3 },
                model: {
                  value: _vm.formData.address,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "address", $$v)
                  },
                  expression: "formData.address"
                }
              })
            ],
            1
          ),
          _c(
            "q-stepper-navigation",
            { staticClass: "justify-end" },
            [
              _vm.hasTeam
                ? _c(
                    "q-btn",
                    {
                      staticClass: "on-left",
                      attrs: { flat: "", "text-color": "grey-7" },
                      on: { click: _vm.handleCancel }
                    },
                    [_vm._v(_vm._s(_vm.$t("cancel")))]
                  )
                : _vm._e(),
              _c(
                "q-btn",
                {
                  staticClass: "on-left",
                  attrs: { flat: "", color: "teal" },
                  on: { click: _vm.handlePrevious }
                },
                [_vm._v(_vm._s(_vm.$t("back")))]
              ),
              _c(
                "q-btn",
                { attrs: { color: "teal" }, on: { click: _vm.handleSubmit } },
                [_vm._v(_vm._s(_vm.$t("save")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("q-inner-loading", { attrs: { visible: _vm.loading } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }